/** 文件管理类 */
class File
{
  constructor(opts = {})
  {
    this.opts = opts
  }
  /**
   * 创建目录文件夹。
   * @method
   * @param   {String}  dir   待创建的文件夹全路径，从uploadfile开始。
   * @returns {Promise}
   */
  createDir(dir)
  {
    return  cx.http.post(cx.url.getUrl('FileSvr'), {cmd: 'createDir', dir})
  }
  /**
   * 删除目录文件夹。
   * @method
   * @param   {String}  dir   待删除的文件夹全路径，从uploadfile开始。
   * @returns {Promise}
   */
  delDir(dir)
  {
    return  cx.http.post(cx.url.getUrl('FileSvr'), {cmd: 'deleteDir', dir})
  }
  /**
   * 删除指定目录下的指定文件。
   * @method
   * @param   {Object}  param         参数对象
   * @param   {String}  param.paths   待删除的文件的路径串，中间用逗号分隔
   * @param   {String}  param.ids     待删除的文件的id串，中间用逗号分隔
   * @returns {Promise}
   */
  delFile({paths, ids})
  {
    let promiseList = paths.split(',').map(dir => cx.http.post(cx.url.getUrl('FileSvr'), {cmd: 'deleteFile', filename: dir}))
    return Promise.all(promiseList)
  }
  /**
   * 查询指定目录下的所有子文件夹（包含所有的叶子文件夹）
   * @method
   * @param   {String}  dir   指定文件夹全路径，从uploadfile开始。
   * @returns {Promise}
   */
  queryDirs(dir)
  {
    return new Promise((resolve, reject) =>
    {
      cx.http.post(cx.url.getUrl('FileSvr'), {cmd: 'getDirs', dir}).then(resolve).catch(err =>
      {
        console.log(err)
        this.createDir(dir).then(_ =>
        {
          cx.http.post(cx.url.getUrl('FileSvr'), {cmd: 'getDirs', dir}).then(resolve).catch(reject)
        }).catch(reject)
      })
    })
  }
  /**
   * 查询指定目录下的所有文件和子文件夹（包含所有的叶子文件和文件夹）
   * @method
   * @param   {String}  dir   指定文件夹全路径，从uploadfile开始。
   * @returns {Promise}
   */
  queryDirFiles(dir, types = '*')
  {
    return new Promise((resolve, reject) =>
    {
      this.queryDirs(dir).then(_ =>
      {
        cx.http.post(cx.url.getUrl('FileSvr'), {cmd: 'getDirFiles', dir, types}).then(resolve).catch(reject)
      })
    })
  }
}
export default File



// WEBPACK FOOTER //
// ./src/plugins/app/com/fileManage/js/File.js